export interface NavigationState {
  isMobileMenuOpen: boolean;
  openDropdown: string | null;
}

export const initialNavigationState: NavigationState = {
  isMobileMenuOpen: false,
  openDropdown: null,
};

export type NavigationAction =
   {
      type: 'SET_OPEN_DROPDOWN';
      id: string | null;
    }
  | {
      type: 'TOGGLE_MOBILE_MENU';
    }
  | {
      type: 'CLOSE_MOBILE_MENU';
    }
  | {
      type: 'CLOSE_ALL';
    };

export function navigationReducer(
  state: NavigationState,
  action: NavigationAction,
): NavigationState {
  switch (action.type) {
    case 'SET_OPEN_DROPDOWN':
      return {
        ...state,
        openDropdown: action.id,
      };

    case 'TOGGLE_MOBILE_MENU':
      return {
        ...state,
        isMobileMenuOpen: !state.isMobileMenuOpen,
        openDropdown: null,
      };

    case 'CLOSE_MOBILE_MENU':
      return {
        ...state,
        isMobileMenuOpen: false,
      };

    case 'CLOSE_ALL':
      return {
        ...state,
        isMobileMenuOpen: false,
        openDropdown: null,
      };

    default:
      return state;
  }
}

export const setOpenDropdown = (
  id: string | null,
): NavigationAction => ({
  type: 'SET_OPEN_DROPDOWN',
  id,
});

export const toggleMobileMenu = (): NavigationAction => ({
  type: 'TOGGLE_MOBILE_MENU',
});

export const closeMobileMenu = (): NavigationAction => ({
  type: 'CLOSE_MOBILE_MENU',
});

export const closeAll = (): NavigationAction => ({
  type: 'CLOSE_ALL',
});